// @ts-nocheck
import BluetoothIcon from '@material-ui/icons/BluetoothConnected';
import GatewayIcon from '@material-ui/icons/Cast';
import HyperTagIcon from '@material-ui/icons/Nfc';
import SmartClassicIcon from '@material-ui/icons/WifiTethering';
import SettingsIcon from '@material-ui/icons/Settings';
import SyncIcon from '@material-ui/icons/Sync';
import WarningIcon from '@material-ui/icons/Warning';
import { Col, Row } from '@sketchpixy/rubix';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { ACCESSORIES_TYPES, BATTERY_IMAGES, BLUE, GREEN, LOCKS_MODELS, ORANGE, RED, SOURCE_TYPE, V364_SYNC_STATUS, VENDORS_LIST } from '../../_config/consts';
import { getLockImage, getMemoryUsageThresholdParameters, getStatusColorFromBatteryLevel } from '../../_config/utils';
import DoorSensorIconCustom from '../CustomIcons/DoorSensorIconCustom.jsx';
import PrivacyIconCustom from '../CustomIcons/PrivacyIconCustom.jsx';
import FormFlatContainer from '../forms/Elements/FormFlatContainer.jsx';
import InfoSection from '../InfoSection/InfoSection.jsx';
import MDButton from '../MDButton/MDButton.jsx';

const LockTechnicalDetailsView = ({ lock, onGatewayClick, onSyncLock, onSyncLockForGateId }) => {
  const isConnectedToGateway = lock.gateway && lock.gateway.id && lock.gateway.name;
  const textStatusColor = getStatusColorFromBatteryLevel(lock.battery);
  const isF9000Cilinder = lock && lock.model === LOCKS_MODELS.F9000;
  const isFullOnlineGate = lock && lock.configuration && lock.configuration.remoteOpenEnabled;
  const canBeOpenRemotely = lock.gatewayId || isFullOnlineGate;
  
  let connectionDescriptionText = canBeOpenRemotely ? <Entity key={lock.id} entity="lockIsSmartClassicOrOnline" /> : <Entity key={lock.id} entity="lockConnectionTypes" data={{ type: lock.connectionType }} />;
  connectionDescriptionText = isConnectedToGateway ? <Entity key={lock.id} entity="lockIsConnectedToGatewayName" data={{ name: lock.gateway.name }} /> : connectionDescriptionText;
  connectionDescriptionText = isF9000Cilinder ? <Entity key={lock.id} entity="lockIsMechatronicCylinder" /> : connectionDescriptionText;
  
  let connectionIcon = isFullOnlineGate ? <SmartClassicIcon style={{ fontSize: 18, color: '#3f3f3f' }} /> : <BluetoothIcon style={{ fontSize: 18, color: '#3f3f3f' }} />;
  connectionIcon = isConnectedToGateway ? <GatewayIcon style={{ fontSize: 18, color: '#3f3f3f' }} /> : connectionIcon;
  connectionIcon = isF9000Cilinder ? null : connectionIcon;
  
  const lockSensor = lock.accessories ? _.find(lock.accessories, accessory => accessory.type === ACCESSORIES_TYPES.DOOR_SENSOR) : null;
  const lockReader = lock.accessories ? _.find(lock.accessories, accessory => accessory.type === ACCESSORIES_TYPES.BT_READER) : null;
  const hasAccessories = lock.hyperTagId || lock.privacyModeEnabled || lockSensor || lockReader;

  return (
    <div style={{ padding: 10 }}>
      {lock.v364SyncStatus === V364_SYNC_STATUS.NOT_SYNCED_SERIAL_NUMBER && (
        <div>
          <InfoSection
            gravity="error"
            title="v364NotSyncedTitle"
            subtitle="v364NotSyncedMessage"
            containerStyle={{ marginBottom: 20 }}
            body={(
              <div style={{ display: 'flex', flexDirection: 'row', gap: 10, justifyContent: 'center' }}>
                <MDButton
                  title={<Entity entity="synchronizeLock" />}
                  icon={<SyncIcon style={{ color: 'white', marginLeft: 10, fontSize: 20 }} />}
                  backgroundColor={ORANGE}
                  containerStyle={{ marginTop: 10, marginBottom: 0 }}
                  onClick={() => onSyncLock(lock.id)}
                />
              </div>
            )}
          />
        </div>
      )}
      {lock.v364SyncStatus === V364_SYNC_STATUS.NOT_SYNCED_GATE_ID && (
        <div>
          <InfoSection
            gravity="error"
            title="v364NotSyncedGateIdTitle"
            subtitle="v364NotSyncedGateIdMessage"
            containerStyle={{ marginBottom: 20 }}
            body={(
              <div style={{ display: 'flex', flexDirection: 'row', gap: 10, justifyContent: 'center' }}>
                <MDButton
                  title={<Entity entity="synchronizeLockForGateId" />}
                  icon={<SyncIcon style={{ color: 'white', marginLeft: 10, fontSize: 20 }} />}
                  backgroundColor={ORANGE}
                  containerStyle={{ marginTop: 10, marginBottom: 0 }}
                  onClick={() => onSyncLockForGateId(lock.id)}
                />
              </div>
            )}
          />
        </div>
      )}
      <FormFlatContainer
        //title="technicalDetails"
        //icon={<SettingsIcon style={{ fontSize: 22, color: '#3f3f3f' }} />}
        containerStyle={{ marginTop: 0 }}
      >
        {/* Connection Section */}
        {lock.connectionType && (
          <>
            <div style={{ marginBottom: 20 }}>
              <h5 style={{ fontSize: 16, margin: 0, marginBottom: 15, color: '#3f3f3f', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                <Entity entity="lockConnectionType" />
              </h5>
              <div style={{ height: 1, backgroundColor: '#e0e0e0', marginBottom: 20 }} />
              <Row>
                <Col sm={6} md={6}>
                  <div style={{ marginBottom: 15 }}>
                    <div 
                      style={{ display: 'flex', alignItems: 'center', cursor: isConnectedToGateway ? 'pointer' : 'default' }}
                      onClick={isConnectedToGateway ? () => onGatewayClick(lock.gateway.id) : null}
                    >
                      <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15, textDecoration: isConnectedToGateway ? 'underline' : 'none' }} className={isConnectedToGateway ? 'link-label' : ''}>
                        {connectionDescriptionText}
                      </h4>
                      {connectionIcon && <span style={{ marginLeft: 10, display: 'flex', alignItems: 'center' }}>{connectionIcon}</span>}
                    </div>
                  </div>
                </Col>
                {lock.configuration && lock.configuration.openMode && (
                  <Col sm={6} md={6}>
                    <div style={{ marginBottom: 15 }}>
                      <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                        <Entity entity="openModeTitle" />
                      </h5>
                      <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>
                        <Entity entity="openModeTranslations" data={{ mode: lock.configuration.openMode }} />
                      </h4>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </>
        )}

        {/* Accessories Section */}
        {hasAccessories && (
          <>
            <div style={{ marginBottom: 20, marginTop: 30 }}>
              <h5 style={{ fontSize: 16, margin: 0, marginBottom: 15, color: '#3f3f3f', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                <Entity entity="accessories" />
              </h5>
              <div style={{ height: 1, backgroundColor: '#e0e0e0', marginBottom: 20 }} />
              <Row>
                {lock.hyperTagId && (
                  <Col sm={6} md={4}>
                    <div style={{ marginBottom: 15 }}>
                      <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                        <Entity entity="hyperTag" />
                      </h5>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <HyperTagIcon style={{ fontSize: 18, color: '#3f3f3f', marginRight: 8 }} />
                        <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>
                          <Entity key={lock.hyperTagId} entity="hyperTagDescription" data={{ hyperTagId: lock.hyperTagId }} />
                        </h4>
                      </div>
                    </div>
                  </Col>
                )}
                {lock.privacyModeEnabled && (
                  <Col sm={6} md={4}>
                    <div style={{ marginBottom: 15 }}>
                      <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                        <Entity entity="doorPrivacyMode" />
                      </h5>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <PrivacyIconCustom style={{ width: 18, color: GREEN, marginRight: 8 }} />
                        <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>
                          <Entity key={lock.id} entity="privacyModeEnabledDescription" />
                        </h4>
                      </div>
                    </div>
                  </Col>
                )}
                {lockSensor && (
                  <Col sm={6} md={4}>
                    <div style={{ marginBottom: 15 }}>
                      <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                        <Entity entity="doorStatus" />
                      </h5>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <DoorSensorIconCustom style={{ width: 40, color: '#3f3f3f', marginRight: 8 }} />
                        <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>
                          <Entity key={lockSensor.id} entity="doorStatusSensorDescription" data={{ sensorId: lockSensor.name }} />
                        </h4>
                      </div>
                    </div>
                  </Col>
                )}
                {lockReader && (
                  <Col sm={6} md={4}>
                    <div style={{ marginBottom: 15 }}>
                      <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                        <Entity entity="smartReader" />
                      </h5>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img style={{ width: 30, height: 30, marginRight: 8 }} src={getLockImage(lockReader.model)} />
                        <h4 style={{ margin: 0, marginRight: 8, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>
                          <Entity key={lockReader.id} entity="lockIsConnectedWithAReaderName" data={{ readerName: lockReader.name }} />
                        </h4>
                        <img alt="battery" src={BATTERY_IMAGES[lockReader.battery]} style={{ width: 20, height: 8.5 }} />
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </>
        )}

        {/* Device Information Section */}
        <div style={{ marginBottom: 20, marginTop: 30 }}>
          <h5 style={{ fontSize: 16, margin: 0, marginBottom: 15, color: '#3f3f3f', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 0.5 }}>
            <Entity entity="deviceInformation" />
          </h5>
          <div style={{ height: 1, backgroundColor: '#e0e0e0', marginBottom: 20 }} />
          <Row>
            <Col sm={6} md={4}>
              <div style={{ marginBottom: 15 }}>
                <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>ID</h5>
                <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>{lock.id}</h4>
              </div>
            </Col>
            <Col sm={6} md={4}>
              <div style={{ marginBottom: 15 }}>
                <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                  <Entity entity="serialNumber" />
                </h5>
                <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>{lock.serialNumber}</h4>
              </div>
            </Col>
            {lock.vendor === VENDORS_LIST.ISEO_ARGO && lock.statusInfo && _.isNumber(lock.statusInfo.memorySize) && _.isNumber(lock.statusInfo.memoryUsed) && (() => {
              const memoryUsageThresholdParameters = getMemoryUsageThresholdParameters(lock.statusInfo.memoryUsed, lock.statusInfo.memorySize);
              const memoryStatusColor = memoryUsageThresholdParameters.color;
              const memoryStatusIcon = memoryUsageThresholdParameters.icon;
              const memoryLastUpdate = lock.statusInfo.updatedAt ? moment(lock.statusInfo.updatedAt).format('LLL') : '---';
              return (
                <Col sm={6} md={4}>
                  <div style={{ marginBottom: 15 }}>
                    <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                      <Entity entity="memoryUsage" />
                    </h5>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {memoryStatusIcon}
                      <h4 style={{ margin: 0, color: memoryStatusColor, fontWeight: 'bold', fontSize: 15 }}>
                        {`${lock.statusInfo.memoryUsed} / ${lock.statusInfo.memorySize} (${L20NContext.getSync('lastUpdate')}: ${memoryLastUpdate})`}
                      </h4>
                    </div>
                  </div>
                </Col>
              );
            })()}
            {lock.vendor === VENDORS_LIST.ISEO_VEGA && (
              <Col sm={6} md={4}>
                <div style={{ marginBottom: 15 }}>
                  <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                    <Entity entity="v364GateId" />
                  </h5>
                  <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>{lock.v364GateId || '---'}</h4>
                </div>
              </Col>
            )}
            <Col sm={6} md={4}>
              <div style={{ marginBottom: 15 }}>
                <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                  <Entity entity="model" />
                </h5>
                <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>{LOCKS_MODELS[lock.model]}</h4>
              </div>
            </Col>
            {lock.vendor && (
              <Col sm={6} md={4}>
                <div style={{ marginBottom: 15 }}>
                  <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                    <Entity entity="vendor" />
                  </h5>
                  <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>
                    <Entity entity="vendorsTranslations" data={{ vendor: lock.vendor }} />
                  </h4>
                </div>
              </Col>
            )}
          </Row>
        </div>

        {/* Power & Battery Section */}
        {!isF9000Cilinder && (
          <>
            <div style={{ marginBottom: 20, marginTop: 30 }}>
              <h5 style={{ fontSize: 16, margin: 0, marginBottom: 15, color: '#3f3f3f', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                <Entity entity="powerAndBattery" />
              </h5>
              <div style={{ height: 1, backgroundColor: '#e0e0e0', marginBottom: 20 }} />
              <Row>
                <Col sm={6} md={4}>
                  <div style={{ marginBottom: 15 }}>
                    <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                      <Entity entity="sourceType" />
                    </h5>
                    <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>
                      <Entity entity="powerSourceTypes" data={{ type: lock.powerSourceType }} />
                    </h4>
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div style={{ marginBottom: 15 }}>
                    <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                      <Entity entity="battery" />
                    </h5>
                    {lock.powerSourceType === SOURCE_TYPE.BATTERY && lock.battery !== undefined && lock.battery !== -1 && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img alt="battery" src={BATTERY_IMAGES[lock.battery]} style={{ width: 28, height: 11 }} />
                        <h4 style={{ margin: 0, marginLeft: 8, color: textStatusColor, fontWeight: 'bold', fontSize: 15 }}>{lock.battery}%</h4>
                      </div>
                    )}
                    {lock.powerSourceType === SOURCE_TYPE.PLUGGED && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img alt="battery" src="/imgs/common/batteryIcons/lightning.png" style={{ width: 14, height: 22, marginRight: 8 }} />
                        <h4 style={{ margin: 0, color: 'goldenrod', fontWeight: 'bold', fontSize: 15 }}>
                          <Entity key={lock.id} entity="powerSourceTypes" data={{ type: lock.powerSourceType }} />
                        </h4>
                      </div>
                    )}
                    {lock.powerSourceType !== SOURCE_TYPE.BATTERY && lock.powerSourceType !== SOURCE_TYPE.PLUGGED && (
                      <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>---</h4>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </>
        )}

        {/* Firmware Information Section */}
        <div style={{ marginBottom: 10 }}>
          <h5 style={{ fontSize: 16, margin: 0, marginBottom: 15, color: '#3f3f3f', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 0.5 }}>
            <Entity entity="firmwareInformation" />
          </h5>
          <div style={{ height: 1, backgroundColor: '#e0e0e0', marginBottom: 20 }} />
          <Row>
            <Col sm={6} md={4}>
              <div style={{ marginBottom: 15 }}>
                <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                  <Entity entity="firmwareVersion" />
                </h5>
                <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>{lock.firmwareVersion || '---'}</h4>
              </div>
            </Col>
            <Col sm={6} md={4}>
              <div style={{ marginBottom: 15 }}>
                <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                  <Entity entity="hardwareVersion" />
                </h5>
                <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>{lock.hardwareVersion || '---'}</h4>
              </div>
            </Col>
            <Col sm={6} md={4}>
              <div style={{ marginBottom: 15 }}>
                <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                  <Entity entity="featureLevel" />
                </h5>
                <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>{lock.featureLevel || '---'}</h4>
              </div>
            </Col>
            <Col sm={6} md={4}>
              <div style={{ marginBottom: 15 }}>
                <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                  <Entity entity="bluetoothFirmwareVersion" />
                </h5>
                <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>{lock.bluetoothFirmwareVersion || '---'}</h4>
              </div>
            </Col>
            <Col sm={6} md={4}>
              <div style={{ marginBottom: 15 }}>
                <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                  <Entity entity="bluetoothHardwareVersion" />
                </h5>
                <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>{lock.bluetoothHardwareVersion || '---'}</h4>
              </div>
            </Col>
            <Col sm={6} md={4}>
              <div style={{ marginBottom: 15 }}>
                <h5 style={{ fontSize: 13, margin: 0, marginBottom: 8, color: '#888' }}>
                  <Entity entity="lastUpdate" />
                </h5>
                <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold', fontSize: 15 }}>{moment(lock.updatedAt).format('LLL') || '---'}</h4>
              </div>
            </Col>
          </Row>
        </div>
      </FormFlatContainer>
    </div>
  );
};

export default LockTechnicalDetailsView;
